"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalTooltip = void 0;
var React = _interopRequireWildcard(require("react"));
var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ConditionalTooltip = _ref => {
  let {
    condition,
    children,
    container,
    content,
    delayHide,
    placement = _alloyReactTooltip.default.PLACEMENTS.TOP,
    style
  } = _ref;
  return condition ? /*#__PURE__*/React.createElement(_alloyReactTooltip.default, {
    placement: placement,
    content: content,
    variant: _alloyReactTooltip.default.VARIANTS.DARK,
    container: container && container.current,
    style: style,
    delayHide: delayHide
  }, children) : children;
};
exports.ConditionalTooltip = ConditionalTooltip;
//# sourceMappingURL=ConditionalTooltip.js.map